import styled from "styled-components";

export const NetworkTabStyle = styled.div`
  padding: 8px;
  .MuiTabs-root {
    margin-bottom: 9px !important;
  }
  @media only screen and (max-width: 600px) {
    padding: 4px;
    .MuiTabs-root {
      margin: 0 4px;
    }
  }
  > h3 {
    color: ${({ theme }) => theme.colors[2]};
  }
  .network-no-data-found {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #c4c4c4;
    font-weight: 600;
    font-size: 20px;
    // height: 82.2vh;
    padding: 0;
    svg {
      padding-top: 10%;
      width: 130px;
      height: 130px;
    }
  }
  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 82.2vh;
    position: absolute;
    width: 100%;
  }
  .list-title {
    margin: 16px 10px 8px;
  }
  .follow-list-title {
    margin: 40px 10px 8px;
  }
  @media only screen and (max-width: 599px) {
    &.container-padding {
      margin-bottom: 80px;
    }
  }
`;

export const FollowCardItem = styled.div`
  position: relative;
  background: ${({ theme }) => theme.Bg1};
  color: ${({ theme }) => theme.text1};
  border-radius: 10px;
  box-shadow: ${({ theme }) => theme.boxShadow1};
  width: 100%;
  height: fit-content;
  .follow-close-icon {
    position: absolute;
    right: 3px;
    top: 2px;
    z-index: 1;
  }
  .follow-img-container {
    position: relative;
  }
  .user-background-img {
    width: 100%;
    height: 60px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    object-fit: cover;
  }
  .user-profile-img {
    background-color: ${({ theme }) => theme.Bg1};
    border-radius: 50%;
    width: 75px;
    height: 75px;
    position: absolute;
    bottom: -90%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99;
    border: 1px solid ${({ theme }) => theme.fieldBorder1};
    object-fit: contain;
    path {
      fill: ${({ theme }) => theme.svg2};
    }
  }
  .follow-content {
    margin-top: 16px;
    padding: 8px;
    text-align: center;
  }
  .follow-names {
    text-align: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    > div:nth-child(1) {
      font-weight: 600;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    > div:nth-child(2) {
      font-size: 14px;
      color: #828282;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .follow-headline {
    font-size: 14px;
    margin-top: 8px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 40px;
  }
  .follow-user-activity {
    font-size: 13px;
    margin-top: 8px;
    display: flex;
    justify-content: space-between;

    > div {
      width: 33%;
    }
  }
  .follow-action {
    margin-top: 8px;
    width: 100%;
    /* font-size: 15px; */
  }
  .follow-action-count {
    font-weight: 600;
    font-size: 14px;
  }
  .action-btn-flex {
    display: flex;
    margin: 6px 0;
  }
`;

export const NetworkPopoverStyle = styled.div`
  li {
    padding: 12px 18px;
    font-size: 15px;
    min-width: 140px;
    svg {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
  }
`;

export const WaterMark = styled.div`
  background-color: ${({ theme }) => theme.lightGray};
  width: 100%;
  height: 70px;
  position: relative;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  .watermark-text {
    position: absolute;
    font-size: 13px;
    color: ${({ theme }) => theme.mode === 'light' ? '#00000014' : '#6b6b6b61'};
    pointer-events: none;
    transform: rotate(-30deg);
  }
  .watermark-text:nth-child(1) {
    top: 10px;
    left: 3%;
  }
  .watermark-text:nth-child(2) {
    top: 40px;
    left: 3%;
  }
  .watermark-text:nth-child(3) {
    top: 10px;
    left: 37%;
  }
  .watermark-text:nth-child(4) {
    top: 40px;
    left: 37%;
  }
  .watermark-text:nth-child(5) {
    top: 10px;
    left: 73%;
  }
  .watermark-text:nth-child(6) {
    top: 40px;
    left: 73%;
  }
`;
